import { useState, useEffect, useCallback } from 'react';
import { ClientBankAccountsApi } from '@/api/clients/client-bank-accounts';

export const useGetClientBankAccounts = (organizationId, options = {}) => {
  const { enabled = true } = options;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchBankAccounts = useCallback(async () => {
    if (!organizationId) return;

    setLoading(true);
    setError(null);

    try {
      const response = await ClientBankAccountsApi.getClientBankAccounts(
        organizationId,
      );
      setData(response.data?.data || []);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to fetch bank accounts');
      console.error('Error fetching bank accounts:', err);
    } finally {
      setLoading(false);
    }
  }, [organizationId]);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }

    fetchBankAccounts();
  }, [fetchBankAccounts, enabled]);

  const refetch = () => {
    fetchBankAccounts();
  };

  const refresh = () => {
    fetchBankAccounts();
  };

  return {
    data,
    loading,
    error,
    refetch,
    refresh,
  };
};
